import React from "react";
import styles from "./style.module.scss";

import icon from "../../assets/image/Frame.png";
import bold from "../../assets/image/boldx.jpg";

function Error() {
  return (
    <div className={styles.load}>
      <img className={styles.load__logo_bold} src={bold} alt="Logo" />
      <div className={styles.load__logo_container}>
        <img className={styles.load__logo} src={icon} alt="Logo" />
        <div>
          <h2>Fire Safety</h2>
          <p>Center</p>
        </div>
      </div>
      <div className={styles.load__cpb}>
        <h3 className={styles.load__cpb__title}>CPBZero</h3>
      </div>
      <span className={styles.load__error}>
        <p>Что-то пошло не так</p>
      </span>
    </div>
  );
}

export default Error;
